module.exports = __webpack_public_path__ + "img/burgerBuilder1.3046c8bb.png";